import { ApiService } from '../../../shared/utils/api-servies';
const apiUrl = 'https://squid-app-tpgns.ondigitalocean.app/';
const headers = { 'telegram-data': window.Telegram.WebApp.initData };
export class SquadsApiService {
    constructor() {
        this.apiService = new ApiService(apiUrl, headers);
    }
    async joinSquad(channelUsername) {
        return this.apiService.post(`guild/join?channelUsername=${channelUsername}`, {});
    }
    async leaveSquad() {
        return this.apiService.post('guild/leave', {});
    }
    async getSquadInfo(squadId) {
        return this.apiService.get(`guild?guildId=${squadId}`, {});
    }
}
